"use strict";

import { MarketSellItem } from 'api/tradeAPICall';
import { cachedBalance } from 'api/walletAPICall';
import ApplicationEvents from 'components/applicationEvents';
import { ViewAppIdIcon, ViewItemIconic } from 'components/commonAssets';
import { spawnDialogWindow } from 'components/dialogHolder';
import { ViewItemMarketDepthOwnWarning } from 'components/itemMarketDepth';
import ViewItemSellEditor from 'components/itemSellEditor';
import { defineSimpleTerm, _I_ } from 'components/locs';
import { spawnDoubleSellErrorModal } from 'components/messageBoxes';
import { ordersSummary } from 'components/orderAssets';
import ViewPriceHistoryGraph from 'components/priceHistoryGraph';
import { walletLimits } from 'components/walletLimitsController';
import { CloseButton } from 'generics/buttons';
import { dataBound } from 'generics/dataBound';
import { IconFontAwesome } from 'generics/icons';
import React from 'react';
import ReactGA from 'react-ga';

class ConfirmSellDialogBody extends React.Component  {
  constructor(props)  {
    super(props);

    this.processSellOrder = () =>  this.placeOrder();
  }

  componentDidMount()  {
    const {  classInfo, appid  } = this.props;
    ReactGA.pageview('item/' + appid + '/' + encodeURI(classInfo.market_hash_name) + '/sell');
  }

  placeOrder()  {
    const  {  isValid, amount: totalAmount,  price,  wished,  agree  }  =  this.sellEditor.getResult();

    if ( (!isValid) || (!agree) )
      return;

    const {
        hash_name,  asssid,  ctxid,  appid,  initialPrice,  classInfo
      } = this.props;


    LogStream("VIEWTRADEDIALOG").info( "placeOrder", appid, ctxid, asssid, totalAmount, price, wished, agree);

    const instances = this.props.instances;
      let allAmount = totalAmount;

        Promise.all ( instances.map (
            ( instance ) => {
                if (allAmount  == 0 ) {
                    return true;
                }

                let instanceAmount;

                if (instance.amount == undefined)
                    instanceAmount = 1;
                else
                    instanceAmount = instance.amount;

                if (instanceAmount > allAmount) {
                    instanceAmount = allAmount;
                }

                allAmount -= instanceAmount;

                return MarketSellItem (
                    appid,
                    ctxid, instance.id, instanceAmount,
                    price, wished, agree
                )
            })
        ).then((resp) => {
            LogStream("VIEWTRADEDIALOG").info("item sold -> ", JSON.stringify(resp, null, "  "));

            ReactGA.event({
              category: 'Order',
              action: 'sell'
            });

            ApplicationEvents.emit_async("EventLog.append", {
                "type": "log",
                "caption": "Trade (SELL) Item",
                "message": "Order issued successfully, please check your orders page later",
                "details": {
                    "response": resp,
                    "marketHashName": hash_name,
                    price,
                    wished,
                    "assetId": asssid,
                    "appId": appid,
                    "ctxId": ctxid
                }
            });

            ApplicationEvents.emit_async("market.updateInventory");
            ApplicationEvents.emit_async("market.ordersUpdate");

        }).catch((reason) => {
            reason = Object.assign({}, reason,
                {
                    "caption": "Trade (SELL) Item Error",
                    "message": ("Failed to sell item:\n" + reason.message)
                });

            const details = ((reason || {}).details || {});
            const code = ((details.response || details.result || {}).error || "");
            if (code == "INVENTORY_FAIL_TO_GET_ASSETS_CLASS") {
                ApplicationEvents.emit_async("market.doubleSellError");
            } else {
                LogStream("VIEWTRADEDIALOG").error("clickSell - Failed (", reason, ")");
                ApplicationEvents.emit_async("EventLog.append", reason);
            }

            ApplicationEvents.emit_async("market.updateInventory");
            ApplicationEvents.emit_async("market.ordersUpdate");
            // return Promise.reject( reason );
        });

    spawnSellProcessingModal( appid, hash_name );
    this.props.removeModal(); // close self
  }


  render()  {
    return (
          <div className="panel-body">
            <div className="view-confirm-dialog-asset-title">{this.props.classInfo.name}</div>
            <div className="view-confirm-dialog-summary">
              <ViewItemIconic classInfo={this.props.classInfo} />
              <div>
                <ViewAppIdIcon appId={this.props.appid} compact />
                <ViewItemMarketDepthOwnWarning  type="buy"  haveOwnOrders={this.props.haveOwnOrders}  />
              </div>
              <ViewItemSellEditor
                    marketFee={this.props.classInfo.market_fee}
                    initialPrice={this.props.initialPrice}
                    processSellOrder={this.processSellOrder}
                    ref={ (sellEditor) => this.sellEditor=sellEditor }
                    balance={this.props.balance}
                    wlimits={this.props.wlimits}
                    orders={this.props.orders}
                    totalAmount={this.props.totalAmount}
                    instances={this.props.instances}
                  />
            </div>
            <ViewPriceHistoryGraph
                    market_name={this.props.hash_name}
                    appid={this.props.appid}
                  />

          </div>
      );
  }
}


// ViewItemSellEditor
const Bound_ConfirmSellDialogBody = dataBound(ConfirmSellDialogBody, {
  "balance":cachedBalance,
  "wlimits":walletLimits,
  "orders" :ordersSummary,
});


class ViewConfirmSellDialog extends React.Component  {
  constructor(props)  {
    super(props);
  }


  onBackdropTouch()  {
    this.props.removeModal();
  }


  render()  {
    return (
        <div className="panel panel-success panel-sm view-confirm-sell-dialog">
          <div className="panel-heading">
            {_I_("SellDialog.title")}
            <CloseButton onClick={this.props.removeModal} />
          </div>
          <Bound_ConfirmSellDialogBody  {...this.props} />
        </div>
      );
  }
}


class ViewSellProcessingDialog extends React.Component  {
  constructor(props)  {
    super(props);

    this.state = {  'doubleSell' : false,  };

    this.refreshCurrentAsset = this.refreshCurrentAsset.bind(this);
    this.doubleSellError     = () => this.setState({ "doubleSell" : true });
  }


  onBackdropTouch()  {
    // this.props.removeModal();
  }


  componentDidMount()  {
    ApplicationEvents.on("market.inventoryUpdateCompleted", this.refreshCurrentAsset );
    ApplicationEvents.on("market.doubleSellError", this.doubleSellError );
  }


  componentWillUnmount()  {
    ApplicationEvents.off("market.inventoryUpdateCompleted", this.refreshCurrentAsset );
    ApplicationEvents.off("market.doubleSellError", this.doubleSellError );
  }


  refreshCurrentAsset()  {
    const { hashName, appId } = this.props;

    ApplicationEvents.emit_async( "market.setCurrentAssetByHash", appId, hashName );
    this.props.removeModal();

    if ( this.state.doubleSell )
      spawnDoubleSellErrorModal();
  }


  render()  {
    return (
        <div className="panel panel-info panel-sm view-is-processing-dialog">
          <div className="panel-heading">
            {_I_("SellProcessingDialog.title")}
          </div>

          <div className="panel-body">
            <div className="text-center">
              <IconFontAwesome type="spinner" size="3x" pulse fixedWidth />&nbsp;
            </div>
            <div className="text-center">
              <b>{_I_("SellProcessingDialog.pleaseWait")}</b>
            </div>
          </div>
        </div>
    );
  }
}


function spawnSellProcessingModal( appId, hashName )  {
  spawnDialogWindow(ViewSellProcessingDialog,  {
      appId,  hashName
    });
}


export default function spawnConfirmSellModal( appid,  ctxid,  asssid,
                              hash_name,  classInfo,
                              initialPrice, haveOwnOrders, totalAmount, instances )  {
  spawnDialogWindow(ViewConfirmSellDialog,  {
      asssid,  initialPrice,  appid,  ctxid,  hash_name,  classInfo,  haveOwnOrders, totalAmount, instances
  });
}


defineSimpleTerm( "SellDialog.title",  "Put an item up for sale",       {
    "ru_RU": "Продажа",
    "cs_CZ": "Put an item up for sale",
    "fr_FR": "Mettre un objet en vente",
    "de_DE": "Ein Item zum Verkauf platzieren",
    "it_IT": "Metti un oggetto in vendita",
    "ko_KR": "판매할 아이템을 올려놓으세요",
    "pl_PL": "Umieść przedmiot na sprzedaż",
    "pt_PT": "Put an item up for sale",
    "es_ES": "Poner un artículo a la venta",
    "zh_CN": "将物品上架待售",
    "zh_TW": "將物品上架待售"
} );


defineSimpleTerm( "SellProcessingDialog.title",  "Processing...",       {
    "ru_RU": "В процессе...",
    "cs_CZ": "Processing...",
    "fr_FR": "En cours...",
    "de_DE": "Bearbeiten...",
    "it_IT": "In processo...",
    "ko_KR": "진행중...",
    "pl_PL": "Przetwarzanie...",
    "pt_PT": "Processing...",
    "es_ES": "Procesando...",
    "zh_CN": "处理中…",
    "zh_TW": "處理中…"
} );


defineSimpleTerm( "SellProcessingDialog.pleaseWait",  "Processing, please wait",       {
    "ru_RU": "Выполняется, пожалуйста подождите",
    "cs_CZ": "Processing, please wait",
    "fr_FR": "En cours, veuillez patienter",
    "de_DE": "Bearbeiten, bitte warten",
    "it_IT": "In processo, attendere",
    "ko_KR": "진행중, 잠시만 기다려 주세요",
    "pl_PL": "Przetwarzanie, prosimy czekać",
    "pt_PT": "Processing, please wait",
    "es_ES": "Procesando, por favor espera",
    "zh_CN": "处理中，请稍候",
    "zh_TW": "處理中，請稍候"
} );

